const {
  REACT_APP_API_URL = '',
  REACT_APP_AWS_IMG_UPLOAD_URL = '',
  REACT_APP_CLOUDFLARE_IMAGES_DELIVERY_BASE = '',
  REACT_APP_STRIPE_KEY = '',
  REACT_APP_GOOGLE_MAPS_ACCESS_TOKEN = '',
  REACT_APP_MAPBOX_ACCESS_TOKEN = '',
  REACT_APP_ENV = '',
  REACT_APP_SITE_URL = '',
  REACT_APP_GA_ID = '',
  REACT_APP_HEAP_APP_ID,
  REACT_APP_PLACES_INPUT_AVAILABLE_COUNTRIES = 'US',
  REACT_APP_STORE_CATEGORY = '',
  REACT_APP_DEFAULT_STORE,
  REACT_APP_DEFAULT_CATEGORY,
  REACT_APP_DEFAULT_SIGNUP_CATEGORY_ID = '',
  REACT_APP_MAKEUP_HAIR_STYLING_CATEGORY_ID = '',
  REACT_APP_PLATFORM_TAKE_RATE_INSTANT_BOOK,
  REACT_APP_PLATFORM_TAKE_RATE_STANDARD,
  REACT_APP_STREAM_CHAT_API_KEY = '',
  REACT_APP_RECAPTCHA_SITE_KEY = '',
} = process.env;

const PHONE_INPUT_SUPPORTED_COUNTRIES = ['AU', 'US', 'GB'];

const PHONE_INPUT_DEFAULT_COUNTRY = 'AU';

const PLACES_INPUT_AVAILABLE_COUNTRIES =
  REACT_APP_PLACES_INPUT_AVAILABLE_COUNTRIES;

// const localApi = 'http://192.168.86.238:5000';
// const localApi = 'http://localhost:5000';
const localApi = 'https://2203-61-68-229-226.ngrok-free.app';
const useLocalApi = false;
const ENV = REACT_APP_ENV;
const API_URL =
  (ENV === 'development' && useLocalApi && `${localApi}/api`) ||
  REACT_APP_API_URL;
const AWS_IMG_UPLOAD_URL = REACT_APP_AWS_IMG_UPLOAD_URL;

/** Base URL for Cloudflare Images delivery (`…/account_hash`); variant is appended as `/imageId/public`. */
const CLOUDFLARE_IMAGES_DELIVERY_BASE =
  (REACT_APP_CLOUDFLARE_IMAGES_DELIVERY_BASE || '').trim() ||
  'https://imagedelivery.net/JJXAAya9ECRMrCHd1XQJvQ';

const STRIPE_KEY = REACT_APP_STRIPE_KEY;
const GOOGLE_MAPS_ACCESS_TOKEN = REACT_APP_GOOGLE_MAPS_ACCESS_TOKEN;
const MAPBOX_ACCESS_TOKEN = REACT_APP_MAPBOX_ACCESS_TOKEN;
const SUPPORT_EMAIL = 'hey@flayr.life';
// const SUPPORT_MOBILE = '+1 (831) 789-2688';
const SUPPORT_MOBILE = '0488 851 655';

const SITE_URL = REACT_APP_SITE_URL;

const HEAP_APP_ID = REACT_APP_HEAP_APP_ID;
const GA_ID = REACT_APP_GA_ID;
const STORE_CATEGORY = REACT_APP_STORE_CATEGORY;
const DEFAULT_STORE = REACT_APP_DEFAULT_STORE;
const DEFAULT_CATEGORY = REACT_APP_DEFAULT_CATEGORY;

/** Catalog slug for the default signup service category (id differs per env). */
const DEFAULT_SIGNUP_CATEGORY_SLUG = 'makeup-hair-styling';

/** Optional Mongo id when slug lookup is unavailable (e.g. offline tests). */
const DEFAULT_SIGNUP_CATEGORY_ID_FALLBACK =
  REACT_APP_DEFAULT_SIGNUP_CATEGORY_ID || '';

/** Primary Mongo id for flat `/signup/...` provider onboarding (makeup-hair-styling). */
const MAKEUP_HAIR_STYLING_CATEGORY_ID =
  REACT_APP_MAKEUP_HAIR_STYLING_CATEGORY_ID ||
  REACT_APP_DEFAULT_SIGNUP_CATEGORY_ID ||
  '';

const LIVE_COURSES_CATEGORY_SLUG = 'makeup-hair-lessons';

const SHOW_PROVIDER_ABOUT_ME = false;

const SHOW_PROVIDER_TESTIMONIALS = false;

const SHOW_OFFER_CODE = true;

const STREAM_CHAT_API_KEY = REACT_APP_STREAM_CHAT_API_KEY;

const LOCAL_STORAGE_USER_INFO_FIELD = 'flayr_user';
const LOCAL_STORAGE_USER_CHAT_FIELD = 'chatUserToken';
const RECAPTCHA_SITE_KEY = REACT_APP_RECAPTCHA_SITE_KEY;

/** Whole-number %; mirrors flayr-api/config/settings.js `takeRates` (used like `resolveTakeRate`). */
const PLATFORM_TAKE_RATE_INSTANT_BOOK =
  REACT_APP_PLATFORM_TAKE_RATE_INSTANT_BOOK === undefined ||
  REACT_APP_PLATFORM_TAKE_RATE_INSTANT_BOOK === ''
    ? 25
    : Number(REACT_APP_PLATFORM_TAKE_RATE_INSTANT_BOOK) || 25;

const PLATFORM_TAKE_RATE_STANDARD =
  REACT_APP_PLATFORM_TAKE_RATE_STANDARD === undefined ||
  REACT_APP_PLATFORM_TAKE_RATE_STANDARD === ''
    ? 25
    : Number(REACT_APP_PLATFORM_TAKE_RATE_STANDARD) || 25;

export {
  ENV,
  API_URL,
  AWS_IMG_UPLOAD_URL,
  CLOUDFLARE_IMAGES_DELIVERY_BASE,
  STRIPE_KEY,
  GOOGLE_MAPS_ACCESS_TOKEN,
  MAPBOX_ACCESS_TOKEN,
  PHONE_INPUT_DEFAULT_COUNTRY,
  PHONE_INPUT_SUPPORTED_COUNTRIES,
  SUPPORT_EMAIL,
  SUPPORT_MOBILE,
  SITE_URL,
  GA_ID,
  HEAP_APP_ID,
  PLACES_INPUT_AVAILABLE_COUNTRIES,
  STORE_CATEGORY,
  DEFAULT_STORE,
  DEFAULT_CATEGORY,
  DEFAULT_SIGNUP_CATEGORY_SLUG,
  DEFAULT_SIGNUP_CATEGORY_ID_FALLBACK,
  MAKEUP_HAIR_STYLING_CATEGORY_ID,
  STREAM_CHAT_API_KEY,
  LOCAL_STORAGE_USER_INFO_FIELD,
  LOCAL_STORAGE_USER_CHAT_FIELD,
  LIVE_COURSES_CATEGORY_SLUG,
  RECAPTCHA_SITE_KEY,
  PLATFORM_TAKE_RATE_INSTANT_BOOK,
  PLATFORM_TAKE_RATE_STANDARD,
  SHOW_PROVIDER_ABOUT_ME,
  SHOW_PROVIDER_TESTIMONIALS,
  SHOW_OFFER_CODE,
};
